import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { fetchDeviceSettings, updateDeviceSetting, updateDeviceTimeZone, getTimeZones, GetImageCatogory } from "js/Api/index";
import { Button } from '../../../../Component/CommonFormEle';
import Select from 'react-select';
import { hasValue } from '../../../../helpers/common_functions'
import Switch from "@mui/material/Switch";
import dayjs from "dayjs";

const DeviceSetings = ({ device, isFamilyorg }) => {
    const [selectedPolicyTab, setSelectedPolicyTab] = useState("volume");
    const [settingsLoading, setSettingsLoading] = useState(false);
    const [settings, setsettings] = useState([]);
    const [timeZones, settimeZones] = useState([]);
    const [TZValue, setTZValue] = useState();
    const [CategoryList, setCategoryList] = useState([]);

    const [checkedDays, setCheckedDays] = useState({ Monday: false, Tuesday: false, Wednesday: false, Thursday: false, Friday: false, Saturday: false, Sunday: false, });
    const dndDaysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const hours = Array.from({ length: 13 }, (_, i) => i.toString().padStart(2, "0"));
    const minutes = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, "0"));
    const periods = ["AM", "PM"];

    const [photoGallerySetting, setphotoGallerySetting] = useState();
    const [dndSetting, setdndSetting] = useState();
    const loadSettings = async () => {
        setSettingsLoading(true);
        try {

            const result_timeZone = await getTimeZones();
            if (result_timeZone.success) {
                settimeZones(result_timeZone.data);

                if (hasValue(device?.timeZone)) {
                    const jsonTZ = JSON.parse(device?.timeZone);
                    var tz = result_timeZone.data.find(a => a.name === jsonTZ.timezone && a.offset === (jsonTZ.offset * 60000))
                    if (hasValue(tz)) {
                        setTZValue(tz);
                    }
                }
            }

            const result = await fetchDeviceSettings(device.id);
            if (result.success) {
                let all_settings = []
                result.data.forEach(a => {
                    all_settings.push({ id: a.id, name: a.name, friendlyName: a.friendlyName, value: a.value, updated: false });
                });

                let dndValue = all_settings.find(a => a.friendlyName === "settings.dnd").value
                if (dndValue !== "") {
                    let parsed = null;

                    try {
                        parsed = dndValue;
                    } catch (e) {
                    }

                    if (parsed) {
                        let dnd = JSON.parse(parsed);
                        if (dnd.isDndEnabled === true) {
                            let { start, end, selectedDay, isDndEnabled, CallHandling } = dnd;
                            const selected = {};
                            dndDaysOfWeek.forEach((d) => {
                                selected[d] = false;
                            });

                            (selectedDay || []).forEach((num) => {
                                const idx = num - 1;
                                if (idx >= 0 && idx < dndDaysOfWeek.length) {
                                    const key = dndDaysOfWeek[idx];
                                    selected[key] = true;
                                }
                            });

                            setCheckedDays(selected);
                        }
                    }
                }
                setdndSetting(dndValue)

                let PhotoValue = all_settings.find(a => a.friendlyName === "settings.photo_gallery").value
                setphotoGallerySetting(PhotoValue);

                setsettings(all_settings)
            }
        } catch (err) {
            console.error("Error fetching device settings:", err);
            toast.error("Failed to load device settings");
        } finally {
            setSettingsLoading(false);
        }
    };

    const LoadCategory = async () => {
        const result = await GetImageCatogory();
        if (result.success) {
            setCategoryList(result.data);
        }
    }

    useEffect(() => {
        LoadCategory();
    }, []);

    useEffect(() => {
        loadSettings();
        LoadCategory();
    }, []);

    const UpdateSettings = async () => {
        for (var i = 0; i < settings.length; i++) {
            if (settings[i].updated === true) {
                if (settings[i].friendlyName === "settings.dnd") {
                    if (getDNDValue()?.isDndEnabled === true) {
                        const selectedDayNumbers = dndDaysOfWeek.filter((dayKey) => checkedDays[dayKey]).map((dayKey) => dndDaysOfWeek.indexOf(dayKey) + 1);
                        let parsed = JSON.parse(dndSetting);
                        let { start, end, selectedDay, isDndEnabled, CallHandling } = parsed;
                        selectedDay = selectedDayNumbers;

                        const valueObj = {
                            start: start,
                            end: end,
                            selectedDay: selectedDay,
                            isDndEnabled: isDndEnabled,
                            CallHandling: CallHandling,
                        };
                        const updateDND = JSON.stringify(valueObj);
                        await updateDeviceSetting(settings[i], device.id, updateDND);
                    }
                    else {
                        await updateDeviceSetting(settings[i], device.id, "");
                    }
                }
                else if (settings[i].friendlyName === "settings.photo_gallery") {
                    await updateDeviceSetting(settings[i], device.id, photoGallerySetting);
                }
                else {
                    await updateDeviceSetting(settings[i], device.id, settings[i].value);
                }
            }
        }
        await loadSettings();
        toast.success(`Setting are updated`);
    };

    const UpdateDevice = async () => {
        let objTZ = "{\"timezone\":\"" + TZValue.name + "\",\"offset\":" + (TZValue.offset / 60000) + "}";
        var objPayload = { device_id: device.id, timeZone: objTZ }
        await updateDeviceTimeZone(objPayload);
        toast.success(`Setting are updated`);
    };

    const languageOptions = [
        { value: 'en', label: 'English - English', image: 'united_kingdom.png' },
        { value: 'es', label: 'Spanish - Español', image: 'spain.png' },
        { value: 'zh', label: 'Chinese - 中文', image: 'china.png' },
        { value: 'hi', label: 'Hindi - हिन्दी', image: 'hindi.png' },
        { value: 'it', label: 'Italian - Italiano', image: 'italy.png' },
        { value: 'vi', label: 'Vietnamese - Tiếng Việt', image: 'vietnamese.png' },
        { value: 'pl', label: 'Polish - Polski', image: 'poland.png' },
        { value: 'fr', label: 'French - Français', image: 'france.png' },
        { value: 'el', label: 'Greek - Ελληνικά', image: 'greece.png' },
        { value: 'ko', label: 'Korean - 한국어', image: 'south_korea.png' },
        { value: 'ja', label: 'Japanese - 日本語', image: 'japan.png' },
        { value: 'fa', label: 'Persian - فارسی', image: 'iran.png' },
        { value: 'ro', label: 'Romanian - Română', image: 'romania.png' },
        { value: 'pt', label: 'Portuguese - Português', image: 'portugal.png' },
        { value: 'de', label: 'German - Deutsch', image: 'germany.png' },
        { value: 'sw', label: 'Swahili - Kiswahili', image: 'tanzania.png' },
        { value: 'ar', label: 'Arabic - العربية', image: 'saudi_arabia.png' }
    ];

    const getSettingValue = (friendly_name, jsonKey) => {
        let find_setting = settings.find(a => a.friendlyName === friendly_name);
        if (find_setting != null) {
            if (hasValue(jsonKey)) {
                return JSON.parse(find_setting.value)[jsonKey];
            }

            return find_setting.value
        }

        return null;
    };

    const setSettingUpdate = (value, friendly_name) => {
        const updated = settings.map(a => {
            if (a.friendlyName === friendly_name) {
                return { ...a, value: value.toString(), updated: true };
            }
            return a;
        });

        setsettings(updated);
    }

    //#region DND

    const getDNDValue = () => {
        let parsed = null;

        try {
            parsed = dndSetting;
        } catch (e) {
        }

        if (!parsed) {
            return "";
        }
        return JSON.parse(parsed);
    }

    const updateDND = (type, value) => {
        setSettingUpdate("", "settings.dnd")
        let parsed = null;

        if (!dndSetting) {
            const nowStart = new Date();
            nowStart.setHours(0, 0, 0, 0);
            const nowEnd = new Date();
            nowEnd.setHours(0, 0, 0, 0);

            parsed = {
                start: nowStart.toISOString(),
                end: nowEnd.toISOString(),
                selectedDay: [],
                isDndEnabled: false,
                CallHandling: "BlockCalls",
            };
        }
        else {
            parsed = JSON.parse(dndSetting);
        }

        let { start, end, selectedDay, isDndEnabled, CallHandling } = parsed;

        if (type === "isDndEnabled") {
            isDndEnabled = value;
        }
        else if (type === "CallHandling") {
            CallHandling = value;
        }
        else if (type === "StartHour" || type === "StartMin" || type === "StartPeriod") {
            const nowStart = new Date(start);

            if (type === "StartHour") {
                nowStart.setHours(value);
            }
            else if (type === "StartMin") {
                nowStart.setMinutes(value);
            }
            else if (type === "StartPeriod") {
                if (value === "AM")
                    nowStart.setHours(nowStart.getHours() - 12)
                else
                    nowStart.setHours(nowStart.getHours() + 12)
            }
            start = nowStart.toISOString()
        }
        else if (type === "EndHour" || type === "EndMin" || type === "EndPeriod") {
            const nowStart = new Date(end);

            if (type === "EndHour") {
                nowStart.setHours(value);
            }
            else if (type === "EndMin") {
                nowStart.setMinutes(value);
            }
            else if (type === "EndPeriod") {
                if (value === "AM")
                    nowStart.setHours(nowStart.getHours() - 12)
                else
                    nowStart.setHours(nowStart.getHours() + 12)
            }
            end = nowStart.toISOString()
        }

        const valueObj = {
            start: start,
            end: end,
            selectedDay: selectedDay,
            isDndEnabled: isDndEnabled,
            CallHandling: CallHandling,
        };
        const valueStr = JSON.stringify(valueObj);
        setdndSetting(valueStr);
    }

    //#endregion

    //#region Photo Gallery

    const updatePhotoGallery = (type, value, category_id) => {
        setSettingUpdate("", "settings.photo_gallery")
        let parsed = JSON.parse(photoGallerySetting);
        let { enable_photo_gallery, show_clock, alternate_clock_photos, enable_day_photos, selected_day_photo_categories } = parsed;

        if (type === "enable_photo_gallery") {
            enable_photo_gallery = value;
            if (value === false && (hasValue(enable_day_photos) && enable_day_photos === false)) {
                show_clock = value;
                alternate_clock_photos = value;
            }
        }
        else if (type === "show_clock") {
            show_clock = value;
        }
        else if (type === "alternate_clock_photos") {
            alternate_clock_photos = value;
        }
        else if (type === "enable_day_photos") {
            enable_day_photos = value;

            if (value === false) {
                selected_day_photo_categories = [];
                if (enable_photo_gallery === false) {
                    show_clock = value;
                    alternate_clock_photos = value;
                }
            }
            else {
                selected_day_photo_categories = CategoryList.map(a => a.id);
            }
        }
        else if (type === "selected_day_photo_categories") {
            if (value === true) {
                selected_day_photo_categories.push(category_id)
            }
            else {
                selected_day_photo_categories = selected_day_photo_categories.filter(a => a !== category_id);
            }
        }

        const valueObj = {
            enable_photo_gallery: enable_photo_gallery,
            show_clock: show_clock,
            alternate_clock_photos: alternate_clock_photos,
            enable_day_photos: enable_day_photos,
            selected_day_photo_categories: selected_day_photo_categories
        };

        const valueStr = JSON.stringify(valueObj);
        setphotoGallerySetting(valueStr);
    }

    //#endregion

    const SettingsTab = [
        ["volume", "Volume"],
        ["language", "Languages"],
        ["timezone", "Time Zone"],
        ["photo_gallery", "Photo Gallery Settings"]
    ];

    if (isFamilyorg) {
        SettingsTab.push(["call_settings", "Call Settings"]);
        SettingsTab.push(["display", "Display"]);
        SettingsTab.push(["dnd", "Do Not Disturb"]);
        SettingsTab.push(["pairing", "Paring"]);
        SettingsTab.push(["clock", "Clock"]);
        SettingsTab.push(["carer_mode", "Carer Mode"]);
        SettingsTab.push(["worker_sign_in", "Visitor Book"]);
    }

    return (
        <div>
            <div className="tab-content">
                <div className="row">
                    {settings.length > 0 &&
                        <>
                            <div className="col-md-2">
                                <nav>
                                    <div className="nav flex-column nav-pills" id="nav-tab" role="tablist">
                                        {SettingsTab.map((tab) => (
                                            <>
                                                <div className={`nav-item nav-link ${selectedPolicyTab === tab[0] ? "active" : ""}`}
                                                    onClick={() => setSelectedPolicyTab(tab[0])} >
                                                    {tab[1]}
                                                </div>

                                            </>
                                        ))}
                                    </div>
                                </nav>
                            </div>
                            <div className="col-md-10">
                                {selectedPolicyTab === "volume" && (
                                    <div>
                                        <div>
                                            <h4>Volume</h4>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-3">
                                                Ringtone and Notification Volume
                                            </div>
                                            <div class="col">
                                                <input type="range" min="0" max="100" value={hasValue(getSettingValue("settings.vol.ring_notification")) ? getSettingValue("settings.vol.ring_notification") : 50}
                                                    onChange={(e) => setSettingUpdate(e.target.value, "settings.vol.ring_notification")} style={{ width: '30%' }} /> {hasValue(getSettingValue("settings.vol.ring_notification")) ? parseFloat(getSettingValue("settings.vol.ring_notification")) : "50"}%
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-3">
                                                Call Volume
                                            </div>
                                            <div class="col">
                                                <input type="range" min="0" max="100" value={getSettingValue("settings.vol.speaker")} onChange={(e) => setSettingUpdate(e.target.value, "settings.vol.speaker")}
                                                    style={{ width: '30%' }} /> {hasValue(getSettingValue("settings.vol.speaker")) ? parseFloat(getSettingValue("settings.vol.speaker")) : ""}%
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {selectedPolicyTab === "language" && (
                                    <div>
                                        <div>
                                            <h4>Languages</h4>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-3">
                                                UI Language
                                            </div>
                                            <div class="col-md-3">
                                                <Select name="ui_lang" options={languageOptions} value={languageOptions.find(a => a.value === getSettingValue("settings.ui_language")) !== undefined ? languageOptions.find(a => a.value === getSettingValue("settings.ui_language")) : languageOptions[0]}
                                                    onChange={(e) => setSettingUpdate(e.value, "settings.ui_language")}
                                                    selectionLimit={1}
                                                    formatOptionLabel={(option) => (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <img src={`/images/ui_language/${option.image}`}
                                                                alt={option.label} style={{ width: '20px', height: '15px', marginRight: '10px' }} />
                                                            <span>{option.label}</span>
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {selectedPolicyTab === "timezone" && (
                                    <div>
                                        <div>
                                            <h4>Time Zone</h4>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-3">
                                                Time Zone
                                            </div>
                                            <div class="col-md-3">
                                                <select className="form-control d-inline" onChange={(e) => { setTZValue(JSON.parse(e.target.value)) }}
                                                    value={hasValue(TZValue) ? JSON.stringify(TZValue) : null}>
                                                    {timeZones.sort((a, b) => a.name.localeCompare(b.name)).map((e) => (<option key={e.name} value={JSON.stringify(e)}> {e.name} </option>))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {selectedPolicyTab === "call_settings" && (
                                    <div>
                                        <div>
                                            <h4>Call Answering</h4>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                Auto-answer incoming calls

                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.auto.answer") === "true" ? true : false} onChange={(e) => setSettingUpdate(e.target.checked, "settings.auto.answer")} color="primary" />
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-3">
                                                Auto-answer delay
                                            </div>
                                            <div class="col">
                                                <input type="text" class="form-control" min="0" max="100" value={getSettingValue("settings.auto.answer.delay")} onChange={(e) => setSettingUpdate(e.target.value, "settings.auto.answer.delay")}
                                                    style={{ width: '8%', display: "inline" }} />s
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-3">
                                                Play sound for incoming calls
                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.auto.audio.alert") === "true" ? true : false} onChange={(e) => setSettingUpdate(e.target.checked, "settings.auto.audio.alert")} color="primary" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                Flash screen for incoming calls
                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.auto.flash_screen.alert") === "true" ? true : false} onChange={(e) => setSettingUpdate(e.target.checked, "settings.auto.flash_screen.alert")} color="primary" />
                                            </div>
                                        </div>

                                        <div class="mt-3">
                                            <h4>Outgoing Calls</h4>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-3">
                                                Allow device to make outgoing calls
                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.outgoing.calls") === "on" ? true : false} onChange={(e) => setSettingUpdate(e.target.checked === true ? "on" : "off", "settings.outgoing.calls")} color="primary" />
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-3">
                                                Contact icon size
                                            </div>
                                            <div class="col">
                                                <select style={{ width: "30%" }} className="form-control" id="role" name="role" value={getSettingValue("settings.max.contacts_per_page")} onChange={(e) => { setSettingUpdate(e.target.value, "settings.max.contacts_per_page") }}>
                                                    <option value="8">Small (8 icons/page)</option>
                                                    <option value="3">Medium (3 icons/page)</option>
                                                    <option value="2">Large (2 icons/page)</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {selectedPolicyTab === "display" && (
                                    <div>
                                        <div>
                                            <h4>Display</h4>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                Adaptive Brightness
                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.display.adaptive_brightness") === "true" ? true : false} onChange={(e) => setSettingUpdate(e.target.checked, "settings.display.adaptive_brightness")} color="primary" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                Manual Brightness
                                            </div>
                                            <div class="col">
                                                <input type="range" min="0" max="100" value={hasValue(getSettingValue("settings.display.brightness")) ? getSettingValue("settings.display.brightness") * 100 : 0}
                                                    disabled={getSettingValue("settings.display.adaptive_brightness") === "true"}
                                                    onChange={(e) => setSettingUpdate((e.target.value / 100), "settings.display.brightness")} style={{ width: '30%' }} /> {hasValue(getSettingValue("settings.display.brightness")) ? parseFloat(getSettingValue("settings.display.brightness") * 100) : ""}%
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-3">
                                                Sleep Mode
                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.display.sleep_mode") === "true" ? true : false} onChange={(e) => setSettingUpdate(e.target.checked, "settings.display.sleep_mode")} color="primary" />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {selectedPolicyTab === "photo_gallery" && (
                                    <div>
                                        <div>
                                            <h4>Photo Gallry</h4>
                                            {console.log(photoGallerySetting)}
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                Enable Photo Gallery
                                            </div>
                                            <div class="col">
                                                <Switch checked={JSON.parse(photoGallerySetting).enable_photo_gallery.toString() === "true" ? true : false} onChange={(e) => updatePhotoGallery("enable_photo_gallery", e.target.checked)} color="primary" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                Day Photo
                                            </div>
                                            <div class="col">
                                                <Switch checked={hasValue(JSON.parse(photoGallerySetting)?.enable_day_photos) && JSON.parse(photoGallerySetting)?.enable_day_photos.toString() === "true" ? true : false} onChange={(e) => updatePhotoGallery("enable_day_photos", e.target.checked)} color="primary" />
                                            </div>
                                        </div>
                                        {(hasValue(JSON.parse(photoGallerySetting)?.enable_day_photos) && JSON.parse(photoGallerySetting)?.enable_day_photos.toString() === "true") &&
                                            <>
                                                <div class="row">
                                                    <div class="col-md-3">

                                                    </div>
                                                    <div class="col">
                                                        {CategoryList.map((a) => <>
                                                            &nbsp;&nbsp;<input type="checkbox" checked={hasValue(JSON.parse(photoGallerySetting)?.selected_day_photo_categories) && JSON.parse(photoGallerySetting).selected_day_photo_categories.includes(a.id)} onChange={(e) => updatePhotoGallery("selected_day_photo_categories", e.target.checked, a.id)} />&nbsp;{a.categoryName}&nbsp;&nbsp;
                                                        </>)}
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {(JSON.parse(photoGallerySetting).enable_photo_gallery.toString() === "true" || (hasValue(JSON.parse(photoGallerySetting)?.enable_day_photos) && JSON.parse(photoGallerySetting)?.enable_day_photos.toString() === "true")) &&
                                            <>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        Show Clock
                                                    </div>
                                                    <div class="col">
                                                        <Switch checked={JSON.parse(photoGallerySetting).show_clock.toString() === "true" ? true : false} onChange={(e) => updatePhotoGallery("show_clock", e.target.checked)} color="primary" />
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-3">
                                                        Alternate Clock & Photos
                                                    </div>
                                                    <div class="col">
                                                        <Switch checked={JSON.parse(photoGallerySetting).alternate_clock_photos.toString() === "true" ? true : false} onChange={(e) => updatePhotoGallery("alternate_clock_photos", e.target.checked)} color="primary" />
                                                    </div>
                                                </div>
                                            </>
                                        }

                                    </div>
                                )}

                                {selectedPolicyTab === "dnd" && (
                                    <div>
                                        <div>
                                            <h4>Do Not Disturb</h4>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                Enable Do Not Disturb
                                            </div>
                                            <div class="col">
                                                <Switch checked={getDNDValue()?.isDndEnabled === true ? true : false} onChange={(e) => updateDND("isDndEnabled", e.target.checked)} color="primary" />
                                            </div>
                                        </div>
                                        {getDNDValue()?.isDndEnabled === true &&
                                            <>
                                                <div class="row mt-3">
                                                    <div class="col-md-3">
                                                        Block or allow calls?
                                                    </div>
                                                    <div class="col">
                                                        <div className="form-check mr-4 ml-3 d-inline">
                                                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked={getDNDValue()?.CallHandling === "BlockCalls"}
                                                                onChange={(e) => { updateDND("CallHandling", "BlockCalls") }} />
                                                            <label className="form-check-label" htmlFor="flexRadioDefault1" >
                                                                Block calls
                                                            </label>
                                                        </div>
                                                        <div className="form-check d-inline">
                                                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked={getDNDValue()?.CallHandling === "AllowCalls"}
                                                                onChange={(e) => { updateDND("CallHandling", "AllowCalls") }} />
                                                            <label className="form-check-label" htmlFor="flexRadioDefault2" >
                                                                Allow calls
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row mt-3">
                                                    <div class="col-md-3">
                                                        Start time
                                                    </div>
                                                    <div class="col">
                                                        <select style={{ width: "auto" }} className="form-control d-inline" onChange={(e) => { updateDND("StartHour", e.target.value) }}
                                                            value={hasValue(getDNDValue()?.start) ? (dayjs(getDNDValue()?.start).format("hh")) : "00"} >
                                                            {hours.map((hour) => (<option key={hour} value={hour}> {hour} </option>))}
                                                        </select>
                                                        <strong>:</strong>
                                                        <select style={{ width: "auto", marginLeft: "1rem" }} className="form-control d-inline" onChange={(e) => { updateDND("StartMin", e.target.value) }}
                                                            value={hasValue(getDNDValue()?.start) ? (dayjs(getDNDValue()?.start).format("mm")) : "00"} >
                                                            {minutes.map((minute) => (<option key={minute} value={minute}> {minute} </option>))}
                                                        </select>
                                                        <select style={{ width: "auto", marginLeft: "1rem" }} className="form-control d-inline" onChange={(e) => { updateDND("StartPeriod", e.target.value) }}
                                                            value={hasValue(getDNDValue()?.start) ? (dayjs(getDNDValue()?.start).format("A")) : "AM"} >
                                                            {periods.map((period) => (<option key={period} value={period}> {period} </option>))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row mt-3">
                                                    <div class="col-md-3">
                                                        End time
                                                    </div>
                                                    <div class="col">
                                                        <select style={{ width: "auto" }} className="form-control d-inline" onChange={(e) => { updateDND("EndHour", e.target.value) }}
                                                            value={hasValue(getDNDValue()?.end) ? (dayjs(getDNDValue()?.end).format("hh")) : "AM"} >
                                                            {hours.map((hour) => (<option key={hour} value={hour}> {hour} </option>))}
                                                        </select>
                                                        <strong>:</strong>
                                                        <select style={{ width: "auto", marginLeft: "1rem" }} className="form-control d-inline" onChange={(e) => { updateDND("EndMin", e.target.value) }}
                                                            value={hasValue(getDNDValue()?.end) ? (dayjs(getDNDValue()?.end).format("mm")) : "AM"} >
                                                            {minutes.map((minute) => (<option key={minute} value={minute}> {minute} </option>))}
                                                        </select>
                                                        <select style={{ width: "auto", marginLeft: "1rem" }} className="form-control d-inline" onChange={(e) => { updateDND("EndPeriod", e.target.value) }}
                                                            value={hasValue(getDNDValue()?.end) ? (dayjs(getDNDValue()?.end).format("A")) : "AM"} >
                                                            {periods.map((period) => (<option key={period} value={period}> {period} </option>))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row mt-3">
                                                    <div class="col-md-3">
                                                        Active days
                                                    </div>
                                                    <div class="col">
                                                        {Object.keys(checkedDays).map((day) => (
                                                            <div key={day} className="form-check form-check-inline">
                                                                <input className="form-check-input" type="checkbox" id={day} value={day} checked={checkedDays[day]}
                                                                    onChange={(e) => {
                                                                        setCheckedDays((prev) => ({
                                                                            ...prev,
                                                                            [day]: e.target.checked,
                                                                        })); setSettingUpdate("", "settings.dnd");
                                                                    }} />
                                                                <label className="form-check-label mr-3" htmlFor={day}>
                                                                    {day.slice(0, 3)}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                )}

                                {selectedPolicyTab === "pairing" && (
                                    <div>
                                        <div>
                                            <h4>Pairing</h4>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5">
                                                Show QR code and Invite by Email button on device
                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.pairing.qr_invite_button") === "true" ? true : false} onChange={(e) => setSettingUpdate(e.target.checked, "settings.pairing.qr_invite_button")} color="primary" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5">
                                                Show Unpair button on device
                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.pairing.unpair_button") === "true" ? true : false} onChange={(e) => setSettingUpdate(e.target.checked, "settings.pairing.unpair_button")} color="primary" />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {selectedPolicyTab === "clock" && (
                                    <div>
                                        <div>
                                            <h4>Clock</h4>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5">
                                                Show clock after inactivity
                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.clock.active") === "true" ? true : false} onChange={(e) => setSettingUpdate(e.target.checked, "settings.clock.active")} color="primary" />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {selectedPolicyTab === "carer_mode" && (
                                    <div>
                                        <div>
                                            <h4>Carer Mode</h4>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-md-12 ml-3">
                                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                                                    checked={getSettingValue("settings.group_leader.carer.mode") === "on"} onChange={(e) => setSettingUpdate(e.target.checked === true ? "on" : "off", "settings.group_leader.carer.mode")} />
                                                <label className="form-check-label" htmlFor="flexRadioDefault1" >
                                                    On
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-md-12 ml-3">
                                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                                                    checked={getSettingValue("settings.group_leader.carer.mode") === "off"} onChange={(e) => setSettingUpdate(e.target.checked === true ? "off" : "off", "settings.group_leader.carer.mode")} />
                                                <label className="form-check-label" htmlFor="flexRadioDefault1" >
                                                    Off
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-md-12 ml-3">
                                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
                                                    checked={getSettingValue("settings.group_leader.carer.mode") === "onhidesetting"} onChange={(e) => setSettingUpdate(e.target.checked === true ? "onhidesetting" : "off", "settings.group_leader.carer.mode")} />
                                                <label className="form-check-label" htmlFor="flexRadioDefault2" >
                                                    On, hide settings
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {selectedPolicyTab === "worker_sign_in" && (
                                    <div>
                                        <div>
                                            <h4>Visitor Book</h4>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5">
                                                Enable visitor Check-in button on CareWindow device
                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.worker_signin") === "true" ? true : false} onChange={(e) => setSettingUpdate(e.target.checked, "settings.worker_signin")} color="primary" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5">
                                                Also enable Check-out
                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.worker_signout") === "true" ? true : false} disabled={getSettingValue("settings.worker_signin") === "false"}
                                                    onChange={(e) => setSettingUpdate(e.target.checked, "settings.worker_signout")} color="primary" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5">
                                                Require multiple taps on visitor Check-in button (to discourage the CareWindow user from opening it)
                                            </div>
                                            <div class="col">
                                                <Switch checked={getSettingValue("settings.worker_checkin_multiple_tap") === "true" ? true : false} disabled={getSettingValue("settings.worker_signin") === "false"}
                                                    onChange={(e) => setSettingUpdate(e.target.checked, "settings.worker_checkin_multiple_tap")} color="primary" />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        {selectedPolicyTab === "timezone" ?
                                            <Button onClick={UpdateDevice} variant="black">
                                                Apply
                                            </Button> :
                                            <Button onClick={UpdateSettings} variant="black">
                                                Apply
                                            </Button>}
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default DeviceSetings;